export class AuthConfig {
  public static LoginConfirmationAction = 'auth/login-registration';
  public static RestoreConfirmationAction = 'auth/restore-confirm';
}
